import moment from "moment";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { formatNumber } from "@angular/common";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Store, Select } from '@ngxs/store';
import { NxDialogService, NxModalRef } from "@aposin/ng-aquila/modal";
import { UserResponse } from "@interfaces/user";
import { SatMotorState } from "@store/sat-motor/sat-motor.state";
import { FormatDecimalPipe } from "@shared/pipes/format-decimal/format-decimal.pipe";
import { RemoveCommaPipe } from "@shared/pipes/remove-comma/remove-comma.pipe";
import { SharedModule } from "@shared/shared.module";
import { VehicleNoValidator } from "@shared/classes/validators/vehicle-no.validator";
import { NumberRangeValidator } from "@shared/classes/validators/number-range.validator";
import { MakeModelComponent } from "@shared/components/modal/make-model/make-model.component";
import { NxMomentDateModule } from "@aposin/ng-aquila/moment-date-adapter";
import { MyDateAdapter } from "@shared/helpers/date.adapter";
import { NxDateAdapter, NX_DATE_FORMATS } from "@aposin/ng-aquila/datefield";
import { SimpleModalComponent } from "../modal/simple-modal/simple-modal.component";
import { DELETE_COVERAGE_FLAG, GET_PREVIOUS_POLICY_NO, SEARCH_MAKE_MODEL, SEARCH_VIX, SELECTED_MAKE_MODEL, STORE_COVERAGE_VEHICLE_DETAILS, SEARCH_ORIXCompanyInfo, SEARCH_VEHICLE_INFORMATION_EXCHANGE, STORE_NCD_INFO, UPDATE_DEFAULT_VIX, STORE_IS_COVERAGE_FIRST_LOAD } from "@store/sat-motor/sat-motor.action";
import { LayoutBreakPointsService } from '@shared/services/layout-break-points/layout-break-points.service';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-vehicle-details",
  standalone: true,
  imports: [SharedModule, NxMomentDateModule],
  providers: [
    { provide: NxDateAdapter, useClass: MyDateAdapter },
    { provide: NX_DATE_FORMATS, useValue: MY_FORMATS }
  ],
  templateUrl: "./vehicle-details.component.html",
  styleUrl: "./vehicle-details.component.scss",
})
export class VehicleDetailsComponent implements OnInit {

  @Select(SatMotorState.motorActionType) actionType$;

  @Select(SatMotorState.endtStep2VehicleDetails) endtVehicleDetailsData$;

  @Input() coverageFmGroup!: FormGroup;
  @Input() vehicleUselov!: any;

  @Output() onChangedVehicle = new EventEmitter<any>();
  @Output() calculatePremium = new EventEmitter<any>();

  vehicleDetailForm: FormGroup;

  dialogRef?: NxModalRef<any>;

  lov: any;
  userInfo: any;
  vehicleUseLov: any;
  agentDetail: any;
  issuanceInfo: any;
  coverageType: any;
  selectedMakeModel: any;
  makeModelDesc: any;
  capacityRange: any;

  isRenewal: boolean = false;
  previousVehicleModelDescp: any = "";
  
  vehicleDetails: any;

  decimalFmt: any;
  numberFmt: any;

  maxlength = 250;
  characterCount: number = 0;

  cCentricInfo: any;
  isCCentricIssuance: boolean = false;

  veriPDPAInfo: any;
  dataORIXLeasingList: any;
  detORIX: any;
  mobileView: boolean = false;
  defaultVix: boolean = false;
  isRequote: boolean = false;
  isDataFromView: boolean = false;
  fCoverageLoadRN: boolean = false;

  previousVehicleCapacity: any = "";

  constructor(
    private fb: FormBuilder,
    private store: Store,
    private readonly dialogService: NxDialogService,
    private layoutService: LayoutBreakPointsService,
  ) {
    this.decimalFmt = new FormatDecimalPipe();
    this.numberFmt = new RemoveCommaPipe();
    this.vehicleDetailForm = this.fb.group({
      region: ["", [Validators.required]],
      vehicleUse: ["", [Validators.required]],
      vehicleNo: ["", [Validators.required, VehicleNoValidator()]],
      vehicleMakeYear: ["", { validators: [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.min(new Date().getFullYear() - 100), Validators.max(new Date().getFullYear())], updateOn: "blur" }],
      makeModel: ["", [Validators.required]],
      vehicleUom: [{ value: "", disabled: true }],
      vehicleCapacity: ["", [Validators.required]],
      engineType: [{ value: "", disabled: true }, [Validators.required]],
      vehicleSeat: ["", [Validators.required, Validators.min(1)]],
      vehicleEngine: ["", [Validators.required]],
      vehicleChassis: ["", [Validators.required]],
      vehicleLoanType: [""],
      vehicleLoanCompany: [""],
      vehiclePurchaseDate: [""],
      makeModelPrintInd: [{value: false, disabled: true }],
      variantDesc: [""],
      leasingCompany: [{value: "", disabled: true}],
      buyerOverwriteInd: [{value: false, disabled: true }],
      makeModelDesc: [""],
    });
  }

  ngOnInit() {
    this.layoutService.subscribeLayoutChanges().subscribe(() => {
      this.mobileView = !this.layoutService.renderDesktop();
    });

    this.coverageFmGroup.controls["vehicleDetails"] = this.vehicleDetailForm;
    
    this.lov = this.store.selectSnapshot<any>((state) => state.SatMotorState.lov);
    this.userInfo = this.store.selectSnapshot<UserResponse>((state) => state.UserState.user);
    this.vehicleUseLov = this.store.selectSnapshot<any>((state) => state.SatMotorState.data.step3.coverage.vehicleUseLov);
    this.agentDetail = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step1.agentDetail);
    this.issuanceInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step1.issuance.issuance);
    this.coverageType = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.coverageType);
    this.cCentricInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState?.cCentricInfo);
    this.isCCentricIssuance = this.store.selectSnapshot<boolean>((state) => state.SatMotorState?.isCCentricIssuance);
    this.veriPDPAInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step1.issuance.pdpa);
    this.detORIX = this.store.selectSnapshot<any>((state) => state.SatMotorState.draftDetails);
    this.defaultVix = this.store.selectSnapshot<any>((state) => state.SatMotorState.defaultVix);
    this.fCoverageLoadRN = this.store.selectSnapshot<any>((state) => state.SatMotorState.fCoverageLoadRN)

    this.capacityRange = { CC: { min: "40", max: "9,999" }, WATT: { min: "0", max: "999,999.99"  } }
    
    if (this.issuanceInfo.cnoteType !== 'NWTR') {
      this.vehicleDetailForm.controls["vehicleNo"].disable();
    }

    if (['NWOO', 'RN'].includes(this.issuanceInfo.cnoteType)) {
      this.isRenewal = true;
      const previousPolicy = this.store.selectSnapshot<any>((state) => state.SatMotorState?.expiredPolicyDetails);
      let risk = previousPolicy?.riskList[0] ?? null;
      if (previousPolicy && risk) {
        if (risk.piamMakeModelDesc && risk.piamMakeModelDesc != '') {
          this.previousVehicleModelDescp = previousPolicy?.riskList[0].piamMakeModelDesc + (previousPolicy?.riskList[0]?.variantFullDesc ? " " + previousPolicy?.riskList[0]?.variantFullDesc : "");
        
        } else  if (risk.vehicleModelDescp && risk.vehicleModelDescp != '') {
          this.previousVehicleModelDescp = risk.vehicleModelDescp;
        }
        if (risk.vehicleCapacity && risk.vehicleCapacity != '') {
          this.previousVehicleCapacity = Number(risk.vehicleCapacity).toLocaleString();
        }
      }
    }
    
    this.selectedMakeModel = this.store.selectSnapshot<any>((state) => state.SatMotorState.data.step3.coverage.selectedMakeModel);

    this.vehicleDetails = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3.coverage?.vehicleDetails);
    if (this.vehicleDetails) {
      this.vehicleDetailForm.patchValue({ 
        ...this.vehicleDetails, vehicleCapacity: formatNumber(this.vehicleDetails.vehicleCapacity, 'en-US'),
        makeModelPrintInd: this.vehicleDetails.makeModelPrintInd === 'Y',
        makeModel: [this.selectedMakeModel?.piamMakeCodeDesc, this.selectedMakeModel?.piamModelCodeDesc, this.selectedMakeModel?.variantFullDesc].join(" ").trim(),
      });

      if (this.vehicleDetails.previousVehicleModelDescp)
        this.previousVehicleModelDescp = this.vehicleDetails.previousVehicleModelDescp;

      if (this.vehicleDetails.prevVehicleCapacity)
        this.previousVehicleCapacity = Number(this.vehicleDetails.prevVehicleCapacity).toLocaleString();

      if ((this.detORIX && this.detORIX?.buyerOverwriteInd && this.detORIX?.leasCompCode === 'ORIX') 
        || (this.vehicleDetails.buyerOverwriteInd && this.vehicleDetails.leasingCompany === 'ORIX')){
        this.onChangeORIXLeasingCompany(this.vehicleDetails);
        this.vehicleDetailForm.controls["buyerOverwriteInd"].enable();
        this.vehicleDetailForm.patchValue({ 
          ...this.vehicleDetails,
          buyerOverwriteInd: this.detORIX ? this.detORIX?.buyerOverwriteInd : this.vehicleDetails.buyerOverwriteInd ? this.vehicleDetails.buyerOverwriteInd : 'N/A',
          leasingCompany: this.detORIX ? this.detORIX?.leasCompCode : this.vehicleDetails.leasingCompany ? this.vehicleDetails.leasingCompany : 'N/A',
        });
      } else if (this.vehicleDetails.vehicleLoanType === 'L' && this.vehicleDetails.vehicleLoanCompany === 'ORIX'){
        this.onChangeORIXLeasingCompany(this.vehicleDetails);
      }

      if (this.makeModelPrintInd.value) {
        this.isRequote = this.store.selectSnapshot<any>((state) => state.SatMotorState.requoteQuotation);
        this.isDataFromView = this.store.selectSnapshot<any>((state) => state.SatMotorState.viewQuotation || state.SatMotorState.updateQuotation);
        const activeQuotation = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step1?.activeQuotation ?? null);
        // const retrieveQuotation = this.store.selectSnapshot<any>(state => state.SatMotorState.retrieveQuotation ?? null);
        const isPreviousPolicy = this.store.selectSnapshot<any>((state) => state.SatMotorState?.previousPolicyDetails);
        let oldData = null;
        if ((activeQuotation) || isPreviousPolicy) {
          oldData = activeQuotation ? activeQuotation.cngeNote : isPreviousPolicy;
        }
        this.makeModelDesc = (oldData?.riskList[0]?.makeModelDesc) ? oldData?.riskList[0].makeModelDesc 
        : this.issuanceInfo?.cnoteType === "RN" || this.isRequote || this.isDataFromView ? this.vehicleDetails?.makeModelDesc : 
        (this.selectedMakeModel?.piamMakeCodeDesc || this.vehicleDetails.makeModelDesc);
        this.vehicleDetailForm.patchValue({
          ...this.vehicleDetails,
          makeModelDesc: this.makeModelDesc,
        });
        this.maxlength = 250 - (this.makeModelDesc?.length ?? 0) - 1;
        this.characterCount = this.variantDesc.value.length;
      }

      if (this.vehicleDetails.vehicleUom === "CC") {
        this.vehicleCapacity.setValidators([Validators.required, Validators.min(1), NumberRangeValidator(this.numberFmt.transform(this.capacityRange.CC.min), this.numberFmt.transform(this.capacityRange.CC.max))]);
        this.vehicleCapacity.updateValueAndValidity();
      } else if (this.vehicleDetails.vehicleUom === "WATT") {
        this.vehicleCapacity.setValidators([Validators.required, Validators.min(0), NumberRangeValidator(this.numberFmt.transform(this.capacityRange.WATT.min), this.numberFmt.transform(this.capacityRange.WATT.max))]);
        this.vehicleCapacity.updateValueAndValidity();
      }
      
      this.appendValidators(this.vehicleLoanType.value, this.vehicleLoanCompany);
    } else {
      this.vehicleDetailForm.patchValue({ region: this.agentDetail.region });
      if (this.issuanceInfo.cnoteType == 'NWNN') {
        this.vehicleDetailForm.patchValue({ vehicleNo: "NA" });
      }
      else if (this.issuanceInfo.cnoteType == 'NWTR') {
        this.vehicleDetailForm.patchValue({ vehicleNo: "" });
      }
      else {
        this.vehicleDetailForm.patchValue({ vehicleNo: this.issuanceInfo.vehicleNo?.toUpperCase() });
      }
      if (this.selectedMakeModel) {
        this.patchMakeModelForm(this.selectedMakeModel);
      }
    }

    if(this.cCentricInfo && this.isCCentricIssuance && !this.vehicleDetails) {
      this.populateCCentricDetails();
    }

    let vixDetails = this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step1?.searchVIX);
    if (vixDetails && vixDetails?.cngeNote?.riskList && vixDetails?.cngeNote?.riskList.length && !this.defaultVix) {
      this.store.dispatch(new UPDATE_DEFAULT_VIX(true));
      let vix = vixDetails?.cngeNote?.riskList[0];
      if (vix?.vehModelNvic) {
        this.store.dispatch(new SEARCH_MAKE_MODEL({ type: vix.vehicleModelDescp, classCode: vix.vehicleClass, yearMnftr: vix.vehicleMakeYear })).subscribe((state) => {
          this.store.dispatch(new SELECTED_MAKE_MODEL(state.SatMotorState.data.step3.coverage.searchMakeModelList.find((mm) => mm.vehModelCodeNvic === vix.vehModelNvic))).subscribe((state) => {
            this.selectedMakeModel = this.store.selectSnapshot<any>((state) => state.SatMotorState.data.step3.coverage.selectedMakeModel);
            this.vehicleDetailForm.patchValue({ 
              ...vix, 
              vehicleCapacity: formatNumber(vix.vehicleCapacity, 'en-US'),
              makeModel: [this.selectedMakeModel?.piamMakeCodeDesc, this.selectedMakeModel?.piamModelCodeDesc, this.selectedMakeModel?.variantFullDesc].join(" ").trim(),
              makeModelPrintInd: vix.makeModelPrintInd === 'Y',
              makeModelDesc: this.selectedMakeModel?.piamMakeCodeDesc
            });
            this.updateMakeModelPrintInd();
          });
        });
      } else {
        this.vehicleDetailForm.patchValue({ 
          ...vix, 
          vehicleCapacity: formatNumber(vix.vehicleCapacity, 'en-US'),
          makeModelPrintInd: vix.makeModelPrintInd === 'Y',
        });
      }
    }

    if (!this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step3?.coverage?.ncdInfo)) {
      if (this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step1?.ncdInfo)) {
        this.store.dispatch(new STORE_NCD_INFO(this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step1?.ncdInfo)));
      }
    }

    this.vehicleMakeYear.valueChanges.subscribe((change) => {
      if (change) {
        if (this.vehicleMakeYear.valid) {
          if (this.makeModel.valid)
            this.resetMakeModelForm();
          this.deleteCoverageIfRequired();
        }
      }
    });

    this.vehicleLoanType.valueChanges.subscribe((change) => {
      // this.vehicleDetailForm.patchValue({ vehicleLoanCompany: "" }); //43728_ORIX - don't remove value from the field.
      this.appendValidators(change, this.vehicleLoanCompany);
    });

    this.vehiclePurchaseDate.valueChanges.subscribe((change) => {
      if (change) {
        if (change.isBefore(moment("1900-01-01"))) {
          this.dialogService.open(SimpleModalComponent, {
            showCloseIcon: false, width: "400px", maxWidth: "400px",
            disableClose: true,
            data: { type: "Warning", message: "Invalid Date, cannot below 01/01/1900." },
          }).afterClosed().subscribe((result) => {
            this.vehiclePurchaseDate.patchValue(null);
          });
        } else if (change.isAfter(moment().add(6, "M"))) {
          this.dialogService.open(SimpleModalComponent, {
            showCloseIcon: false, width: "400px", maxWidth: "400px",
            disableClose: true,
            data: { type: "Warning", message: "Invalid Date, cannot more than " + moment().add(6, "M").format('DD/MM/YYYY') + "." },
          }).afterClosed().subscribe((result) => {
            this.vehiclePurchaseDate.patchValue(null);
          });
        }
      }
    });

    this.makeModelPrintInd.valueChanges.subscribe((change) => {
      this.selectedMakeModel = this.store.selectSnapshot<any>((state) => state.SatMotorState.data.step3.coverage.selectedMakeModel);
      this.isRequote = this.store.selectSnapshot<any>((state) => state.SatMotorState.requoteQuotation);
      this.isDataFromView = this.store.selectSnapshot<any>((state) => state.SatMotorState.viewQuotation || state.SatMotorState.updateQuotation);
      let variantCodeDescFullDesc = (this.selectedMakeModel?.piamModelCodeDesc ?? "") + (this.selectedMakeModel?.variantFullDesc ? " " + this.selectedMakeModel?.variantFullDesc:"");
      if(!change) this.vehicleDetails={ ...this.vehicleDetails, variantDesc: "" }
      let variantDescp = change ? this.vehicleDetails?.variantDesc : "";
      this.vehicleDetailForm.patchValue({ 
        variantDesc: change ? variantDescp ? variantDescp : variantCodeDescFullDesc : "" 
      });
      
      if (this.fCoverageLoadRN) {
        this.store.dispatch(new STORE_IS_COVERAGE_FIRST_LOAD(true));
        if (change) {
          this.makeModelDesc = this.retrieveMakeModelDesc();
          this.characterCount = variantCodeDescFullDesc.length;
          this.maxlength = 250 - this.makeModelDesc.length - 1;
          this.vehicleDetailForm.patchValue({
            makeModelDesc: this.makeModelDesc,
          }, { emitEvent: false });
          this.vehicleDetails = {
            ...this.vehicleDetails,
            makeModelDesc: this.makeModelDesc,
          }
        } else {
          this.makeModelDesc = "";
          this.characterCount = 0;
          this.maxlength = 250;
        }
      }

      this.appendValidators(change, this.variantDesc);
    });
    
    this.updateMakeModelPrintInd();
  }

  retrieveMakeModelDesc() {
    let makeModelDescRet = "";
    makeModelDescRet = this.selectedMakeModel?.piamMakeCodeDesc;
    return makeModelDescRet;
  }
  
  openPopupMakeModel() {
    if (!this.vehicleMakeYear.valid) {
      this.vehicleMakeYear.markAllAsTouched();
      return;
    }

    this.makeModel.markAsUntouched();

    this.dialogRef = this.dialogService.open(MakeModelComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      autoFocus: false,
      width: "95%",
      maxWidth: "930px",
      data: { 
        region: this.region.value, 
        vehicleClass: this.vehicleUseLov.filter((v) => v.code === this.vehicleUse.value)?.[0]?.vehicleClass,
        yearMnftr: this.vehicleMakeYear.value
      }
    });

    this.dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.store.dispatch(new SELECTED_MAKE_MODEL(result.item)).subscribe((state) => {
          this.resetMakeModelForm();
          this.patchMakeModelForm(result);
        });

        if (result.item.uom === "CC") {
          this.vehicleCapacity.setValidators([Validators.required, Validators.min(1), NumberRangeValidator(this.numberFmt.transform(this.capacityRange.CC.min), this.numberFmt.transform(this.capacityRange.CC.max))]);
          this.vehicleCapacity.updateValueAndValidity();
        } else if (result.item.uom === "WATT") {
          this.vehicleCapacity.setValidators([Validators.required, Validators.min(0), NumberRangeValidator(this.numberFmt.transform(this.capacityRange.WATT.min), this.numberFmt.transform(this.capacityRange.WATT.max))]);
          this.vehicleCapacity.updateValueAndValidity();
        }
        
        if (this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3.coverage?.coverageType)) {
          this.onChangedVehicle.emit({ formControlName: "makeModel" });
        }
        this.updateMakeModelPrintInd();
      }
    });
  }

  onKeyUp(event: any) {
    this.characterCount = this.makeModelDesc?.length + 1 + event.target.value.length;
  }

  onChangeRegion($event) {
    if (this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3.coverage?.coverageType)) {
      this.onChangedVehicle.emit({ formControlName: "region", value: $event.value });
    }
  }

  onChangeUseOfVehicle($event) {
    if (this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3.coverage?.coverageType)) {
      this.onChangedVehicle.emit({ formControlName: "vehicleUse", value: $event.value });
    }
  }
  
  onChangeVehicleNo($event) {
    if ($event.target.value) {
      this.store.dispatch(new GET_PREVIOUS_POLICY_NO({ vehicleNo: $event.target.value, agentCode: this.agentDetail.agentCode })).subscribe((state) => {
        let previousPolicy = state.SatMotorState?.previousPolicyDetails;
        if (previousPolicy) {
          if (previousPolicy.riskList[0].prevNcdInsurer === "216" && this.calculateDiff(previousPolicy.expiryDate) < 90 ) {
            let vehicle = previousPolicy?.riskList?.[0];
            if (vehicle) {
              if (vehicle?.vehModelNvic) {
                let vehicleUsePayload = this.vehicleUse.value || vehicle.vehicleUse;
                this.store.dispatch(new SEARCH_MAKE_MODEL({ type: vehicle.piamMakeModelDesc, classCode: this.vehicleUseLov.filter((v) => v.code === vehicleUsePayload)[0].vehicleClass, yearMnftr: vehicle.vehicleMakeYear })).subscribe((state) => {
                  this.store.dispatch(new SELECTED_MAKE_MODEL(state.SatMotorState.data.step3.coverage.searchMakeModelList.find((mm) => mm.vehModelCodeNvic === vehicle.vehModelNvic))).subscribe((state) => {
                    this.selectedMakeModel = this.store.selectSnapshot<any>((state) => state.SatMotorState.data.step3.coverage.selectedMakeModel);
                    this.vehicleDetailForm.patchValue({ 
                      ...vehicle, 
                      vehicleCapacity: formatNumber(vehicle.vehicleCapacity, 'en-US'),
                      makeModel: [this.selectedMakeModel?.piamMakeCodeDesc, this.selectedMakeModel?.piamModelCodeDesc, this.selectedMakeModel?.variantFullDesc].join(" ").trim(),
                      makeModelPrintInd: vehicle.makeModelPrintInd === 'Y',
                      makeModelDesc: this.selectedMakeModel?.piamMakeCodeDesc
                    });
                    this.updateMakeModelPrintInd();
                  });
                });
              }
              else {
                this.vehicleDetailForm.patchValue({ 
                  ...vehicle, 
                  vehicleCapacity: formatNumber(vehicle.vehicleCapacity, 'en-US'),
                  makeModelPrintInd: vehicle.makeModelPrintInd === 'Y',
                });
                this.updateMakeModelPrintInd();
              }
            }
          }
        } else {
          this.store.dispatch(new SEARCH_VIX({ cngeNote: { vehicleNo: $event.target.value, productCode: this.issuanceInfo.productCode  } })).subscribe((state) => {
            this.store.dispatch(new UPDATE_DEFAULT_VIX(true));
            let vix = state.SatMotorState?.motor?.step1?.searchVIX?.cngeNote?.riskList[0];
            if (vix) {
              if (vix?.vehModelNvic) {
                this.store.dispatch(new SEARCH_MAKE_MODEL({ type: vix.vehicleModelDescp, classCode: this.vehicleUseLov.filter((v) => v.code === this.vehicleUse.value)[0].vehicleClass, yearMnftr: vix.vehicleMakeYear })).subscribe((state) => {
                  this.store.dispatch(new SELECTED_MAKE_MODEL(state.SatMotorState.data.step3.coverage.searchMakeModelList.find((mm) => mm.vehModelCodeNvic === vix.vehModelNvic))).subscribe((state) => {
                    this.selectedMakeModel = this.store.selectSnapshot<any>((state) => state.SatMotorState.data.step3.coverage.selectedMakeModel);
                    this.vehicleDetailForm.patchValue({ 
                      ...vix, 
                      vehicleCapacity: formatNumber(vix.vehicleCapacity, 'en-US'),
                      makeModel: [this.selectedMakeModel?.piamMakeCodeDesc, this.selectedMakeModel?.piamModelCodeDesc, this.selectedMakeModel?.variantFullDesc].join(" ").trim(),
                      makeModelPrintInd: vix.makeModelPrintInd === 'Y',
                      makeModelDesc: this.selectedMakeModel?.piamMakeCodeDesc
                    });
                    this.updateMakeModelPrintInd();
                  });
                });
              }
              else {
                this.vehicleDetailForm.patchValue({ 
                  ...vix, 
                  vehicleCapacity: formatNumber(vix.vehicleCapacity, 'en-US'),
                  makeModelPrintInd: vix.makeModelPrintInd === 'Y',
                });
                this.updateMakeModelPrintInd();
              }
            }
          })
        }
        this.updateMakeModelPrintInd();
      });
    }
  }

  onChangeCapacity($event, comma: boolean, calculate: boolean) {
    if (!comma) {
      if ($event.target.value)
        this.vehicleCapacity.patchValue(this.numberFmt.transform($event.target.value));
    } else {
      if ($event.target.value)
        this.vehicleCapacity.patchValue(formatNumber(this.numberFmt.transform($event.target.value), 'en-US'));
      if (calculate)
        if (this.vehicleCapacity.valid)
          this.onChangedVehicle.emit({ formControlName: "vehicleCapacity", value: this.numberFmt.transform($event.target.value) });
    }
  }

  onChangeChassis($event) {
    if (this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3.coverage?.coverageType)) {
      this.onChangedVehicle.emit({ formControlName: "vehicleChassis", value: $event.value });
    }
  }

  patchMakeModelForm(dt) {
    let data = dt.item ?? dt;
    let capacityValue = (data.capacity || data.vehicleCapacity);
    this.vehicleDetailForm.patchValue({
      makeModel: [data.piamMakeCodeDesc, data.piamModelCodeDesc, data.variantFullDesc].join(" ").trim(),
      vehicleUom: data.uom || data.vehicleUom,
      vehicleCapacity: capacityValue ? formatNumber(capacityValue, 'en-US') : "",
      engineType: data.engineType,
      vehicleSeat: data.seat || data.vehicleSeat,
      makeModelDesc: this.selectedMakeModel?.piamMakeCodeDesc || this.vehicleDetails.makeModelDesc
    });
  }

  resetMakeModelForm() {
    this.vehicleDetailForm.patchValue({
      makeModel: "",
      vehicleUom: "",
      vehicleCapacity: "",
      engineType: "",
      vehicleSeat: "",
      makeModelPrintInd: false,
      variantDesc: "", 
    });
    this.makeModelDesc = "";
    this.characterCount = 0;
  }

  private appendValidators(change: any, element: AbstractControl<any>) {
    if (change) {
      element.setValidators([Validators.required]);
    } else {
      element.clearValidators();
    }

    if (element)
      element.updateValueAndValidity();
  }

  deleteCoverageIfRequired() {
    if (this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3.coverage?.coverageType)) {
      this.store.dispatch(new DELETE_COVERAGE_FLAG({ forceDelete: true }));
    }
  }

  calculateDiff(sentDate) {
    let date1:any = new Date(sentDate);
    let date2:any = new Date();
    let diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));

    return diffDays;
  }

  onLoanTypeChange(event: any) {
    if (event.value === null) {
      this.vehicleLoanType?.setValue('');
      this.vehicleLoanCompany.markAsUntouched();
    }
  }

  onLoanCompanyChange($event: any) {
    let loanCompany = $event.target.value;
    if (loanCompany) {
      this.vehicleLoanType.setValidators([Validators.required]);
    } else {
      this.vehicleLoanType.clearValidators();
    }
    this.vehicleLoanType.updateValueAndValidity();
    this.vehicleLoanCompany.setValue(loanCompany);
  }

  populateCCentricDetails() {
    this.vehicleMakeYear.setValue(this.cCentricInfo?.cngeRiskVehicle?.vehicleMakeYear);
    this.vehicleEngine.setValue(this.cCentricInfo?.cngeRiskVehicle?.vehicleEngine?.toUpperCase());
    this.vehicleChassis.setValue(this.cCentricInfo?.cngeRiskVehicle?.vehicleChassis?.toUpperCase());

    let ccentricVehicleNo = this.cCentricInfo?.cngeRiskVehicle?.vehicleNo;
    if (this.issuanceInfo.cnoteType == 'NWTR') {
      this.vehicleNo.setValue(ccentricVehicleNo);
      this.onChangeVehicleNo({ target: { value: ccentricVehicleNo } });
    }
  }

  onChangeORIXLeasingCompany($event: any){
    if (this.vehicleLoanCompany.value === "ORIX" && this.vehicleLoanType?.value === "L") {
      if (this.veriPDPAInfo.consentDetails.einvoiceConsentInd ){

        this.store.dispatch(new SEARCH_ORIXCompanyInfo({ agentCode: this.agentDetail.agentCode, loanCompany: this.vehicleLoanCompany.value, 
          loanType: this.vehicleLoanType.value, vehType: this.issuanceInfo.productCode, eInvoiceInd: this.veriPDPAInfo.consentDetails.einvoiceConsentInd}))
        .subscribe((state) => {
          if (state){
            this.dataORIXLeasingList = state.SatMotorState?.lov?.searchORIXCompany;

            if(state.SatMotorState?.motor.step3.isORIXLeaseCompany) {
              this.vehicleDetailForm.controls["leasingCompany"].enable();
            }
          }
        })
      }
    }
    else {
      this.vehicleDetailForm.controls["leasingCompany"].disable();
      this.vehicleDetailForm.controls["leasingCompany"].setValue(null);
      this.vehicleDetailForm.controls["buyerOverwriteInd"].disable();
      this.vehicleDetailForm.controls["buyerOverwriteInd"].setValue(false);
    }
  }

  onLeasingCompanyChange(){
    if (this.vehicleDetailForm.controls["leasingCompany"].value === "ORIX"){
      this.vehicleDetailForm.controls["vehicleLoanType"].disable();
      this.vehicleDetailForm.controls["vehicleLoanCompany"].disable();
      this.vehicleDetailForm.controls["buyerOverwriteInd"].enable();
      this.vehicleDetailForm.controls["buyerOverwriteInd"].setValue(true);
    } else if (this.vehicleDetailForm.controls["leasingCompany"].value === null){
      this.vehicleDetailForm.controls["leasingCompany"].disable();
      this.vehicleDetailForm.patchValue({ vehicleLoanType: null });
      this.vehicleDetailForm.controls["vehicleLoanType"].enable();
      this.vehicleDetailForm.controls["vehicleLoanType"].setValue(null);
      this.vehicleLoanType.clearValidators();
      this.vehicleDetailForm.patchValue({ vehicleLoanCompany: "" });
      this.vehicleDetailForm.controls["vehicleLoanCompany"].enable();
      this.vehicleDetailForm.controls["vehicleLoanCompany"].setValue("");
      this.appendValidators("", this.vehicleLoanCompany);
      this.vehicleLoanCompany.clearValidators();
      this.vehicleDetailForm.controls["buyerOverwriteInd"].disable();
      this.vehicleDetailForm.controls["buyerOverwriteInd"].setValue(false);
    }
  }
  
  valBuyerOverwriteUnCheck ($event: any){
    if (!this.buyerOverwriteInd.value){
      $event.preventDefault();
      return;
    }
    if (this.vehicleDetailForm.get('buyerOverwriteInd').value !== false && this.leasingCompany.value !== null && this.vehicleLoanCompany.value === 'ORIX'){
      this.vehicleDetailForm.patchValue({ vehicleLoanType: null });
      this.vehicleDetailForm.controls["vehicleLoanType"].enable();
      this.vehicleDetailForm.controls["vehicleLoanType"].setValue(null);
      this.appendValidators("", this.vehicleLoanType);
      this.vehicleDetailForm.patchValue({ vehicleLoanCompany: "" });
      this.vehicleDetailForm.controls["vehicleLoanCompany"].enable();
      this.vehicleDetailForm.controls["vehicleLoanCompany"].setValue("");
      this.appendValidators("", this.vehicleLoanCompany);
      this.vehicleDetailForm.patchValue({ leasingCompany: null });
      this.vehicleDetailForm.get('leasingCompany')?.disable();
      this.vehicleDetailForm.controls["leasingCompany"].setValue(null);
      this.leasingCompany?.markAsUntouched();
      this.vehicleDetailForm.patchValue({ buyerOverwriteInd: null });
      this.vehicleDetailForm.get('buyerOverwriteInd')?.disable();
      this.vehicleDetailForm.controls["buyerOverwriteInd"].setValue(false);
    }
  }

  get region() {
    return this.vehicleDetailForm.controls["region"];
  }
  get vehicleUse() {
    return this.vehicleDetailForm.controls["vehicleUse"];
  }

  get vehicleNo() {
    return this.vehicleDetailForm.controls["vehicleNo"];
  }

  get vehicleMakeYear() {
    return this.vehicleDetailForm.controls["vehicleMakeYear"];
  }

  get makeModel() {
    return this.vehicleDetailForm.controls["makeModel"];
  }

  get vehicleUom() {
    return this.vehicleDetailForm.controls["vehicleUom"];
  }

  get vehicleCapacity() {
    return this.vehicleDetailForm.controls["vehicleCapacity"];
  }

  get vehicleSeat() {
    return this.vehicleDetailForm.controls["vehicleSeat"];
  }

  get vehicleEngine() {
    return this.vehicleDetailForm.controls["vehicleEngine"];
  }

  get vehicleChassis() {
    return this.vehicleDetailForm.controls["vehicleChassis"];
  }

  get vehicleLoanType() {
    return this.vehicleDetailForm.controls["vehicleLoanType"];
  }

  get vehicleLoanCompany() {
    return this.vehicleDetailForm.controls["vehicleLoanCompany"];
  }
  
  get vehiclePurchaseDate() {
    return this.vehicleDetailForm.controls["vehiclePurchaseDate"];
  }

  get makeModelPrintInd() {
    return this.vehicleDetailForm.controls["makeModelPrintInd"];
  }

  get variantDesc() {
    return this.vehicleDetailForm.controls["variantDesc"];
  }

  get leasingCompany() {
    return this.vehicleDetailForm.controls["leasingCompany"];
  }

  get buyerOverwriteInd() {
    return this.vehicleDetailForm.controls["buyerOverwriteInd"];
  }

  updateMakeModelPrintInd(){
    const formValue = this.vehicleDetailForm.getRawValue();
    if(formValue?.makeModel && formValue?.makeModel != ''){
      this.vehicleDetailForm.controls["makeModelPrintInd"].enable();
    }
  }

}